<template>
    <div>
        <div class>
            <Steps :active="3" align-center>
                <Step :title="$t('offering.offbase')" @click.native="on_click('offbaseAdd')" />
                <Step :title="$t('offering.offeringResources')" @click.native="on_click('offeringResourcesAdd')" />
                <Step :title="$t('offering.offconditionAdd')" @click.native="on_click('offconditionAdd')" />
                <Step :title="$t('offering.offnoticeAdd')" />
                <Step :title="$t('offering.offpriceAdd')" @click.native="on_click('offpriceAdd')" />
                <Step :title="$t('offering.offinvestAdd')" @click.native="on_click('offinvestAdd')" />
                <Step :title="$t('offering.offabilityAdd')" @click.native="on_click('offabilityAdd')" />
            </Steps>
        </div>
        <br/>
        <div class='divMessage'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{{ message }}</div>
        <br/>
        <el-card class="aui-card--fill"
                 shadow="never">
            <el-form ref="dataForm"  :inline="true" :model="dataForm" :rules="rules"  >
                <el-row>
                    <el-col :span="1"><div class="grid-content" /></el-col>
                </el-row>
                <el-row>
                    <el-col :span="1"><div class="grid-content" /></el-col>
                    <el-col :span="3">
                        <el-form-item label="通知方式" prop="notice"></el-form-item>
                    </el-col>
                    <el-col :span="3">
                        <el-form-item >
                            <el-checkbox v-model="noticeEmailFalgTemp" disabled >邮件
                                <el-tooltip placement="right" effect="light" >
                                    <div slot="content">{{ $t('couse.noticetDealerMsg') }}</div>
                                    <em class="el-icon-question"></em>
                                </el-tooltip>
                            </el-checkbox>
                        </el-form-item>
                    </el-col>
                    <el-col :span="4">
                        <el-form-item label="设置模板内容"></el-form-item>
                    </el-col>
                    <el-col :span="3">
                        <el-select v-bind:disabled="disableEmail" v-model="emailTemplateIdTemp" placeholder="默认模板">
                            <el-option
                                    v-for="item in options"
                                    :key="item.value"
                                    :label="item.label"
                                    :value="item.value">
                            </el-option>
                        </el-select>
                    </el-col>

                </el-row>
                <el-row>
                    <el-col :span="11"><div class="grid-content" /></el-col>
                    <el-col :span="12">
<!--                        <input style="background:transparent;border:1px solid #ffffff">-->
<!--                        <label id="test">{{this.emailContentTemp}}-->
<!--                            <el-input  v-model="emailContentTemp" type="textarea" style="background:transparent;border:1px solid #ffffff"-->
<!--                                       @change="changEmail2"-->
<!--                                       @keyup.delete.native="changEmail2"-->
<!--                                       @keyup.native="changEmail2"-->
<!--                                       :rows="12"></el-input></label>-->
                        <!--                        <el-input v-bind:disabled="disableEmailContent" v-model="emailContentTemp" type="textarea" :rows="12"></el-input>-->
                        <div style="white-space:pre;  border-left:1px solid #E4E7ED;border-right:1px solid #E4E7ED;border-top:1px solid #E4E7ED;border-bottom:1px solid #E4E7ED">
                            <div @click="changEmail" style="word-wrap:break-word"> <span class="ces">{{this.emailContentTemp2}}</span></div>
                        <div style="margin-top:-1px;" class="email">
<!--                        <el-input  v-model="emailContentTemp" type="textarea" class="myClass"-->
<!--                                   @change="changEmail"-->
<!--                                   @keyup.delete.native="changEmail2"-->
<!--                                   @keyup.native="changEmail"-->
<!--                                   :rows="12"></el-input>  v-model="emailContentTemp"-->
<!--                            <el-input  type="textarea" v-model="emailContentTemp" ref="emailContentTemp"-->
<!--                                       :rows="12"></el-input>-->
<!--                            -->
<!--                            <textarea v-model="emailContentTemp" style= "overflow:hidden; resize:none; "></textarea>-->
                            <el-input  type="textarea" v-model="emailContentTemp" ref="emailContentTemp"
                                       :rows="5"
                                       :autosize="{ minRows: 5, maxRows: 200 }"
                                       :resize="none">
                            </el-input>

                        </div>
                        </div>
                    </el-col>
                </el-row>
                <br/>
                <br/>
                <el-row>
                    <el-col :span="1"><div class="grid-content" /></el-col>
                    <el-col :span="3">
                        <div class="grid-content" />
                    </el-col>
                    <el-col :span="3">
                        <el-form-item >
                            <el-checkbox v-model="noticeLetterFlagTemp"  disabled >APP消息
                                <el-tooltip placement="right" effect="light" >
                                    <div slot="content">{{ $t('couse.noticetMsg') }}</div>
                                    <em class="el-icon-question"></em>
                                </el-tooltip>
                            </el-checkbox>
                        </el-form-item>
                    </el-col>
                    <el-col :span="4">
                        <el-form-item label="设置模板内容"></el-form-item>
                    </el-col>
                    <el-col :span="3">
                        <el-select v-bind:disabled="disableLetter" v-model="letterTemplateIdTemp" placeholder="默认模板">
                            <el-option
                                    v-for="item in options"
                                    :key="item.value"
                                    :label="item.label"
                                    :value="item.value">
                            </el-option>
                        </el-select>
                    </el-col>

                </el-row>
                <el-row>
                    <el-col :span="11"><div class="grid-content" /></el-col>
                    <el-col :span="12">
                        <el-input v-bind:disabled="disableLetterContent" v-model="letterContentTemp" type="textarea" :rows="12"></el-input>
                    </el-col>
                </el-row>
                <br/>
                <br/>
                <el-row>
                    <el-col :span="1"><div class="grid-content" /></el-col>
                    <el-col :span="3">
                        <div class="grid-content" />
                    </el-col>
                    <el-col :span="3">
                        <el-form-item >
                            <el-checkbox v-model="noteSmsFlagTemp" disabled >短信
                                <el-tooltip placement="right" effect="light" >
                                    <div slot="content">{{ $t('couse.noticetMsg') }}</div>
                                    <em class="el-icon-question"></em>
                                </el-tooltip>
                            </el-checkbox>
                        </el-form-item>
                    </el-col>
                    <el-col :span="4">
                        <el-form-item label="设置模板内容"></el-form-item>
                    </el-col>
                    <el-col :span="3">
                        <el-select v-bind:disabled="disableSms" v-model="smsTemplateIdTemp" placeholder="默认模板">
                            <el-option
                                    v-for="item in options"
                                    :key="item.value"
                                    :label="item.label"
                                    :value="item.value">
                            </el-option>
                        </el-select>
                    </el-col>

                </el-row>
                <el-row>
                    <el-col :span="11"><div class="grid-content" /></el-col>
                    <el-col :span="12">
                        <el-input v-bind:disabled="disableSmsContent" v-model="smsContentTemp" type="textarea" :rows="12"></el-input>
                    </el-col>
                </el-row>
            </el-form>
        </el-card>
        <div>
            <el-row style="float:right; margin-bottom: 60px;">
                <el-col :span="16"><div class="grid-content" /></el-col>
                <el-button v-if="$hasPermission('learning:offeringinfo:offeringNoticeSave') && $hasPermission('learning:offeringinfo:offeringPriceSave')"
                           @click="btnSaveNextStep"  type="primary">{{ $t("course.saveAndNext") }}</el-button>
                <el-button v-if="$hasPermission('learning:offeringinfo:offeringNoticeSave')"
                           @click="btnSave"  type="primary">{{ $t("course.save") }}</el-button>
                <ZElButton @click="btnCancel" >{{ $t("course.cancel") }}</ZElButton>
            </el-row>
        </div>
    </div>
</template>

<script>
    // 这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
    // 例如：import 《组件名称》 from '《组件路径》';
    // 基本信息   offbaseAdd
    // 报名条件   offconditionAdd
    // 报名通知   offnoticeAdd
    // 价格相关   offpriceAdd
    // 调查问卷   offinvestAdd
    // 能力项设置 offabilityAdd
    import Steps from '../../common/steps/index'
    import Step from '../../common/steps/src/step'
    import ZElButton from '../../common/button/index'

    export default {
// import引入的组件需要注入到对象中才能使用
        components: { Steps, Step, ZElButton },
        props: ['message', 'passOfferingId'],
        inject: ['toTop'],
        data () {
            return {
                noticeEmailFalgTemp: true,
                noticeLetterFlagTemp: true,
                noteSmsFlagTemp: true,
                emailContentTemp3: '姓名，您好\n' +
                    '贵司学员姓名已经成功报名如下排期，请提醒学员做好日程安排。\n' +
                    '课程名称：\n' +
                    '排期编号：\n' +
                    '排期开始时间：\n' +
                    '排期结束时间：\n' +
                    '排期场地：\n'+
                    '冻结金额：\n'+
                    '*最终结算金额以培训课程结束后，培训师确认学员出勤和成绩时的费用结算为准。\n',
                // emailContentTemp2: '【姓名】，您好\n' +
                //     '贵司学员【姓名】已经成功报名如下课程。如报名为面授课程，请提醒学员提前做好行程安排；如为远程虚拟场地培训，请提醒学员登陆悦学苑中登记的个人邮箱查看上课链接。\n' +
                //     '课程名称：\n' +
                //     '排期编号：\n' +
                //     '排期开始时间：\n' +
                //     '排期结束时间：\n' +
                //     '排期场地：\n',

                emailContentTemp2: '姓名，您好\n' +
                    '贵司学员姓名已经成功报名如下排期，如报名为面授课程，请提醒学员做好行程安排；请务必随身携带二代居民身份证，入场时需在培训中心的人员信息识别设备上使用身份证进行身份核实并签到（为保证签到信息完整请注意课程结束后离场也需要使用身份证签出）；如为远程虚拟场地培训，请提醒学员请在培训开始前一天登陆悦学苑中登记的电子邮箱查看上课链接。\n' +
                    '课程名称：\n' +
                    '排期编码：\n' +
                    '排期开始时间：\n' +
                    '排期结束时间：\n' +
                    '排期场地： \n' +
                    '冻结金额：\n'+
                    '*最终结算金额以培训课程结束后，培训师确认学员出勤和成绩时的费用结算为准。\n'+
//                    '如您报名的是宝马中国评估中心测评，测评机构将在测评前1-2周和您联系，通知测评准备材料及付款事宜，具体测评时间可能根据评估人数有所调整，请以测评机构的邮件通知为准。\n'+
                    '如您报名宝马中国评估中心测评，则该系统通知仅作为测评需求收集。\n'+
                    '实际测评排期与费用收取流程，请务必等待测评服务机构与您联系后确认。\n'+
                    '\n' +
                    '上课期间请注意：\n'+
                    '1.参训人员按规定时间到场、签到，严禁迟到早退。\n'+
                    '2.请严格遵守课堂纪律以及培训场地的相关规定，如指定区域禁止吸烟等。\n',
                emailContentTemp: '',
                // letterContentTemp: '【姓名】，您好\n' +
                //     '您已成功报名如下课程。如报名为面授课程，请提前做好行程安排；如为远程虚拟场地培训，请登陆悦学苑中登记的个人邮箱查看上课链接。\n' +
                //     '课程名称：\n' +
                //     '排期编号：\n' +
                //     '排期开始时间：\n' +
                //     '排期结束时间：\n' +
                //     '排期场地：',
                // smsContentTemp: '【悦学苑】XXX，您好\n' +
                //     '您已成功报名如下课程。如报名为面授课程，请提前做好行程安排；如为远程虚拟场地培训，请登陆悦学苑中登记的个人邮箱查看上课链接。\n' +
                //     '课程名称：\n' +
                //     '排期编号：\n' +
                //     '排期开始时间：\n' +
                //     '排期结束时间：\n' +
                //     '排期场地：',
                letterContentTemp: '【姓名】，您好\n' +
                    '您已成功报名如下课程。如报名为面授课程，请提前做好行程安排；请务必随身携带二代居民身份证，入场时需在培训中心的人员信息识别设备上使用身份证进行身份核实并签到（为保证签到信息完整请注意课程结束后离场也需要使用身份证签出）；如为远程虚拟场地培训，请在培训开始前一天登陆悦学苑中登记的电子邮箱查看上课链接。\n' +
                    '课程名称：\n' +
                    '排期编码：\n' +
                    '排期开始时间：\n' +
                    '排期结束时间：\n' +
                    '排期场地：\n' +
                    '如您报名宝马中国评估中心测评，则该系统通知仅作为测评需求收集。\n' +
                    '实际测评排期与费用收取流程，请务必等待测评服务机构与您联系后确认。\n',
                smsContentTemp: '【悦学苑】XXX，您好\n' +
                    '您已成功报名如下课程。如报名为面授课程，请提前做好行程安排；请务必随身携带二代居民身份证，入场时需在培训中心的人员信息识别设备上使用身份证进行身份核实并签到（为保证签到信息完整请注意课程结束后离场也需要使用身份证签出）；如为远程虚拟场地培训，请在培训开始前一天登陆悦学苑中登记的电子邮箱查看上课链接。\n' +
                    '课程名称：\n' +
                    '排期编码：\n' +
                    '排期开始时间：\n' +
                    '排期结束时间：\n' +
                    '排期场地： \n' +
                    '如您报名宝马中国评估中心测评，则该系统通知仅作为测评需求收集。\n' +
                    '实际测评排期与费用收取流程，请务必等待测评服务机构与您联系后确认。\n',
                emailTemplateIdTemp: 1, // Email值
                letterTemplateIdTemp: 1, // APP消息
                smsTemplateIdTemp: 1, // 短信

                dataForm: {
                    offeringId: '',
                    emailTemplateId: 1, // Email值
                    letterTemplateId: 1, // APP消息
                    smsTemplateId: 1, // 短信

                    emailContent: 'defaultTemp',
                    letterContent: 'defaultTemp',
                    smsContent: 'defaultTemp',

                    noticeEmailFalg: true,
                    noticeLetterFlag: true,
                    noteSmsFlag: true,


                },
                disableEmail: true,
                disableEmailContent: true,
                disableLetter: true,
                disableLetterContent: true,
                disableSms: true,
                disableSmsContent: true,
                options: [{
                    value: 1,
                    label: '默认模板'
                }],
                openTemp: {
                    1: 'defaultTemp'
                },
                value: '',
                rules: {
                    notice: [
                        { required: true, message: '', trigger: 'change' }
                    ]
                }
            }
        },
        // 监听属性 类似于data概念
        computed: {},
        // 监控data中的数据变化
        watch: {},
        // 生命周期 - 创建完成（可以访问当前this实例）
        created () {
            // TODO 点击保存并下一步进入页面初始化数据
            this.$eventHub.$on('offbaseAdd', data => {
                this.again()
            })
        },
        // 生命周期 - 挂载完成（可以访问DOM元素）
        mounted () {
            console.log('mounted')
        },
        beforeCreate () {
            console.log('beforeCreate')
        }, // 生命周期 - 创建之前
        beforeMount () {
            console.log('beforeMount')
        }, // 生命周期 - 挂载之前
        beforeUpdate () {
            console.log('beforeUpdate')
        }, // 生命周期 - 更新之前
        updated () {
            console.log('updated')
        }, // 生命周期 - 更新之后
        beforeDestroy () {
            console.log('beforeDestroy')
        }, // 生命周期 - 销毁之前
        destroyed () {
            console.log('destroyed')
        }, // 生命周期 - 销毁完成
        activated () {
            if (this.$route.query.offeringId !== undefined && this.$route.query.offeringId !== '') {
                // #TODO 再次进入页面初始化数据
                console.log('再次进入 abilityItems')
                console.log(this.$route.query.offeringId)
                this.init(this.$route.query.offeringId)
            }
        },
        // 方法集合
        methods: {
            change(obj) {
        var text = obj.value; // 获取input的值
        if (text.match(/^http/gi) == null) { // 判断是否以http开头
            obj.value = "http://" + text; // 不以http开头，则http:// + 文本
        }
    },
            changEmail2(){
                //this.emailContentTemp=this.emailContentTemp
                var text = this.emailContentTemp; // 获取input的值
                var s=this.emailContentTemp2
                this.$message(text.match(s) )
                if (text.match(s) == null) { // 判断是否以http开头
                    this.emailContentTemp = "http://" + text; // 不以http开头，则http:// + 文本
                }
                // console.info('是否为默认指定模板的内容')
                // if(this.emailContentTemp.indexOf(this.emailContentTemp2)!=0){
                //     this.$message({
                //         message: this.$t('offering.signUpNoticedefError'),//'原模版内容不能修改',
                //         type: 'error',
                //         duration: 2000
                //     })
                //     return false
                // }
            },
            changEmail(){
                this.$refs.emailContentTemp.$el.children[0].focus()
                // this.emailContentTemp3=this.emailContentTemp2+this.emailContentTemp
                // console.info('是否为默认指定模板的内容')
                // if(this.emailContentTemp.indexOf(this.emailContentTemp2)!=0){
                //     this.$message({
                //         message: this.$t('offering.signUpNoticedefError'),//'原模版内容不能修改',
                //         type: 'error',
                //         duration: 2000
                //     })
                //     return false
                // }
            },
            // 设置初始化为空
            again () {
                // TODO data 数据设置为空
            },
            // 初始化数据
            init (offeringId) {
                this.again()
                this.getOfferingBaseInfo(offeringId)
            },
            getOfferingBaseInfo (offeringId) {
                this.dataForm.offeringId = offeringId
                if (this.dataForm.offeringId === null || this.dataForm.offeringId === '') {
                    return
                }
                this.$request.get('/learning/base/offeringinfo/get/' + this.dataForm.offeringId
                ).then((res, total, code, data) => {
                    this.dataForm = data.data
                    if (this.dataForm.noticeEmailFalg === 'true') {
                        this.dataForm.noticeEmailFalg = true
                    } else {
                        this.dataForm.noticeEmailFalg = false
                    }
                    if (this.dataForm.noticeLetterFlag === 'true') {
                        this.dataForm.noticeLetterFlag = true
                    } else {
                        this.dataForm.noticeLetterFlag = false
                    }
                    if (this.dataForm.noteSmsFlag === 'true') {
                        this.dataForm.noteSmsFlag = true
                    } else {
                        this.dataForm.noteSmsFlag = false
                    }
                    if(this.dataForm.emailContent !=='defaultTemp'){
                        console.info('初始文本'+this.dataForm.emailContent)
                        console.info('初始文本'+this.dataForm.emailContent.length)
                        console.info('初始文本'+this.emailContentTemp2.length)
                        this.emailContentTemp =this.dataForm.emailContent.slice(this.emailContentTemp2.length)
                    }
                    this.handleEmailCheck(this.dataForm.noticeEmailFalg)
                    this.handleLetterCheck(this.dataForm.noticeLetterFlag)
                    this.handleSmsCheck(this.dataForm.noteSmsFlag)
                }).catch((err) => {
                    console.log(err)
                })
            },
            // 勾选Email时触发
            handleEmailCheck (val) {
                // if (val) {
                //   this.disableEmail = false
                //   this.disableEmailContent = false
                // } else {
                //   this.disableEmail = true
                //   this.disableEmailContent = true
                // }
            },
            // 勾选APP消息时触发
            handleLetterCheck (val) {
                // if (val) {
                //   this.disableLetter = false
                //   this.disableLetterContent = false
                // } else {
                //   this.disableLetter = true
                //   this.disableLetterContent = true
                // }
            },
            // 勾选短信时触发
            handleSmsCheck (val) {
                // if (val) {
                //   this.disableSms = false
                //   this.disableSmsContent = false
                // } else {
                //   this.disableSms = true
                //   this.disableSmsContent = true
                // }
            },
            // Email 下拉框选择后触发
            emailContentChange (val) {
                // this.dataForm.emailContent = this.openTemp[val]
            },

            // APP消息 下拉框选择后触发
            letterContentChange (val) {
                // this.dataForm.letterContent = this.openTemp[val]
            },

            // 短信 下拉框选择后触发
            smsContentChange (val) {
                // this.dataForm.smsContent = this.openTemp[val]
            },
            // 判断是否勾选
            isCheck () {
                return this.dataForm.noticeEmailFalg === false && this.dataForm.noticeLetterFlag === false && this.dataForm.noteSmsFlag === false
            },
            // 验证判断
            isCheckNotice () {
                //添加字符串判断
                // this.emailContentTemp.indexOf(this,emailContentTemp2)
                console.info('是否为默认指定模板的内容')
                // if(this.emailContentTemp.indexOf(this.emailContentTemp2)!=0){
                //     this.$message({
                //         message: this.$t('offering.signUpNoticedefError'),//'原模版内容不能修改',
                //         type: 'error',
                //         duration: 2000
                //     })
                //     return false
                // }
                console.log('isCheckNotice')
                console.log(this.dataForm)
                if (this.isCheck()) {
                    this.$message({
                        message: this.$t('offering.signUpNoticeError'),
                        type: 'error',
                        duration: 2000
                    })
                    return false
                }
                if (this.dataForm.noticeEmailFalg === true) {
                    if (this.dataForm.emailContent.trim() === '') {
                        this.$message({
                            message: this.$t('offering.signUpNoticeConError'),
                            type: 'error',
                            duration: 2000
                        })
                        return false
                    }
                }
                if (this.dataForm.noticeLetterFlag === true) {
                    console.log('this.dataForm.noticeLetterFlag')
                    console.log(this.dataForm)
                    if (this.dataForm.letterContent.trim() === '') {
                        this.$message({
                            message: this.$t('offering.signUpNoticeConError'),
                            type: 'error',
                            duration: 2000
                        })
                        return false
                    }
                }
                if (this.dataForm.noteSmsFlag === true) {
                    if (this.dataForm.smsContent.trim() === '') {
                        this.$message({
                            message: this.$t('offering.signUpNoticeConError'),
                            type: 'error',
                            duration: 2000
                        })
                        return false
                    }
                }
                return true
            },
            // 保存方法
            btnSave () {
                this.dataForm.offeringId = this.passOfferingId
                if (this.isCheckNotice()) {
                    this.dataForm.emailContent=this.emailContentTemp2+this.emailContentTemp
                    this.$request.put(`/learning/base/offeringinfo/offeringNoticeUpdate`,
                        this.dataForm
                    ).then((res, total, code, data) => {
                        if (data.code === 13000000) {
                            this.$message({
                                message: this.$t(data.msg),
                                type: 'error',
                                duration: 2000
                            })
                        } else if (data.code === 1) {
                            this.$message({
                                message: this.$t('prompt.success'),
                                type: 'success',
                                duration: 2000
                            })
                            this.tabRemove()
                            this.$router.push({
                                name: 'learning-offering-offeringlist'
                            })
                        }
                    }).catch((err) => {
                        console.log(err)
                    })
                }
            },
            // 保存并下一步
            btnSaveNextStep () {
                console.log('btnSaveNextStep')
                console.log(this.dataForm)
                // if (this.isCheckNotice()) {
                //     this.dataForm.offeringId = this.passOfferingId
                //     this.$message({
                //         message: this.$t('prompt.success'),
                //         type: 'success',
                //         duration: 2000
                //     })
                //     this.sendMsg()
                // }
                if (this.isCheckNotice()) {
                    this.dataForm.offeringId = this.passOfferingId
                    this.dataForm.emailContent=this.emailContentTemp2+this.emailContentTemp
                    this.$request.put(`/learning/base/offeringinfo/offeringNoticeUpdate`,
                        this.dataForm
                    ).then((res, total, code, data) => {
                        if (data.code === 13000000) {
                            this.$message({
                                message: this.$t(data.msg),
                                type: 'error',
                                duration: 2000
                            })
                        } else if (data.code === 1) {
                            this.$message({
                                message: this.$t('prompt.success'),
                                type: 'success',
                                duration: 2000
                            })
                            this.sendMsg()
                        }
                    }).catch((err) => {
                        console.log(err)
                    })
                }
            },
            // 向父页面传递消息 跳转下一页面
            sendMsg () {
                this.toTop()
                this.$emit('onShowModer', 'offpricesend')
            },
            // 向父页面传递消息 保存页面
            sendSave () {
                this.$emit('onShowModer', 'offpriceSave')
            },
            // 点击导航跳转页面
            on_click (e) {
                this.$confirm('离开本页将不保存当前正在编辑的数据, 确定离开? ', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.$emit('onShowModer', e)
                }).catch((err) => {
                    console.log(err)
                })
            },
            // 取消按钮
            btnCancel () {
                this.$confirm('离开本页将不保存当前正在编辑的数据, 确定离开? ', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.tabRemove()
                }).catch((err) => {
                    console.log(err)
                })
            },
            // 删除当前页面
            tabRemove () {
                let tabName = this.$store.state.contentTabsActiveName
                if (tabName === 'home') {
                    return false
                }
                this.$store.state.contentTabs = this.$store.state.contentTabs.filter(item => item.name !== tabName)
                if (this.$store.state.contentTabs.length <= 0) {
                    this.$store.state.sidebarMenuActiveName = this.$store.state.contentTabsActiveName = 'home'
                    return false
                }
                // 当前选中tab被删除
                if (tabName === this.$store.state.contentTabsActiveName) {
                    this.$router.push({ name: this.$store.state.contentTabs[this.$store.state.contentTabs.length - 1].name })
                }
            }
        }
    }
</script>
<style>

    input, textarea, select, button {
        text-rendering: auto;
        color: initial;
        letter-spacing: normal;
        word-spacing: normal;
        text-transform: none;
        text-indent: 0px;
        text-shadow: none;
        display: inline-block;
        text-align: start;
        margin: 0em 0em 0em 0em;
        font: 15px Arial, sans-serif;
    }
    textarea{
        font: 18px Arial, sans-serif;
        font-family: sans-serif;
    }
</style>
<style lang='scss' scoped>
    // @import url(); 引入公共css类
    .grid-content {
        border-radius: 4px;
        min-height: 20px;
    }
    #test {
        border: 1px solid #020102;
        font-family: "微软雅黑","黑体",serif;
        font-size: 18px;
    }
    #test input {
        font-family: "微软雅黑","黑体",serif;
        font-size: 18px;
        padding: 0;
        margin: 0;
        border-style: none;
        background-color: transparent;
        outline-style: none;
    }
    .ces{
        padding: 5px 1.5px  1.5px 15px;
        text-rendering: auto;
        color: initial;
        letter-spacing: normal;
        word-spacing: normal;
        text-transform: none;
        text-indent: 0px;
        text-shadow: none;
        display: inline-block;
        text-align: start;
        margin: 0em 0em 0em 0em;
        line-height: 1.5;
        /*font: 14px Arial;*/
        font-family: sans-serif;
        /*white-space: normal !important;*/
        white-space: pre-wrap;

    }
      .el-textarea__inner:focus{outline:0;border-color: transparent
    }
     .el-textarea__inner:hover{outline:0;border-color: transparent
    }
     .el-textarea__inner{outline:0;border-color: transparent
    }
    .email  .el-textarea__inner {
        display: block;
        /*resize: vertical;*/
        resize: none;
        padding: 1px 15px;
        line-height: 1.4;
        -webkit-box-sizing: border-box;
        box-sizing: border-box;
        width: 100%;
        font-size: inherit;
        color: #020102;
        background-color: #FFF;
        background-image: none;
        border: 0px solid #DCDFE6;
        border-radius: 4px;
        -webkit-transition: border-color .2s cubic-bezier(.645,.045,.355,1);
        transition: border-color .2s cubic-bezier(.645,.045,.355,1);
    }
    /* textarea {*/
    /*    -webkit-appearance: textarea;*/
    /*    background-color: white;*/
    /*    -webkit-rtl-ordering: logical;*/
    /*    user-select: text;*/
    /*    flex-direction: column;*/
    /*    resize: none;*/
    /*    cursor: auto;*/
    /*    white-space: pre-wrap;*/
    /*    word-wrap: break-word;*/
    /*    border-width: 1px;*/
    /*    border-style: solid;*/
    /*    border-color: initial;*/
    /*    border-image: initial;*/
    /*    padding: 2px;*/
    /*}*/
</style>
